module.exports = __webpack_public_path__ + "static/media/zoom-in.60c84eee.svg";